/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataWarehouse = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 1.906 22 6.35V22H2V6.35zM12 20h1v-1h-1zm1-3v-3h3v-3H8v9h2v-3zm2 2v1h1v-1zm1-2v-1h-1v1zm2 3h2V7.65l-8-3.556L4 7.65V20h2V9h12z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDataWarehouse as DataWarehouse };
